import { Link } from 'react-router-dom';
import LegalText from '../components/LegalText';
import LegalTop from '../components/LegalTop';
import './legal.css';

export default function TermsPage() {
  return (
    <main className="legal-page">
      <div className="legal-card">
        <LegalTop title="Terms & Conditions" titleStyle={{ fontSize: '1.2rem', fontWeight: 800 }} />

        <LegalText which="terms">
        <p className="legal-updated">Last updated: October 3, 2026</p>

        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By using InGo, you agree to these Terms and all applicable local laws. If you do
            not agree, please do not use the app.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. User Accounts</h2>
          <p>
            You are responsible for keeping your account information accurate and secure. You
            must not share your credentials with others.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Service Usage</h2>
          <p>
            You agree to use the platform lawfully and respectfully. Any misuse, fraud, or
            abuse may result in account suspension.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Payments and Refunds</h2>
          <p>
            Charges are shown before confirmation where possible. Refund decisions depend on
            the order status and support review.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Limitation of Liability</h2>
          <p>
            InGo is provided on an as-available basis. We are not liable for indirect losses,
            delays, or interruptions beyond reasonable control.
          </p>
        </section>
        </LegalText>

        <p className="legal-footnote">
          Questions? See{' '}
          <Link to="/help-support" className="legal-inline-link">
            Help &amp; support
          </Link>{' '}
          or{' '}
          <Link to="/privacy-policy" className="legal-inline-link">
            Privacy policy
          </Link>
          .
        </p>
      </div>
    </main>
  );
}
